// Billing can export a cycle only once it ended at least 24h 5min ago.
const CYCLE_EXPORT_DELAY_MS = (24 * 60 + 5) * 60 * 1000;

export const getLatestExportableBillingCycle = (): Date => {
  const cutOff = new Date(Date.now() - CYCLE_EXPORT_DELAY_MS);
  return new Date(
    Date.UTC(cutOff.getUTCFullYear(), cutOff.getUTCMonth() - 1, 1),
  );
};
